import React from 'react';
import { Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const getMethodByType = type => {
    switch (type) {
        case 'sms':
            return 'SMS text message';
        case 'totp':
            return 'Authenticator app';
        default:
            return '';
    }
};

const useStyles = makeStyles(theme => ({
    divider: {
        margin: `0px -${theme.spacing(2)}px`,
        position: 'relative',
    },
    infoColumn: {
        display: 'inline-block',
        width: '50%',
    },
    actionColumn: {
        textAlign: 'right',
        display: 'inline-block',
        width: '50%',
    },
    root: {
        margin: '16px 0px',
        display: 'flex',
    },
    action: {
        display: 'inline-block',
        marginLeft: theme.spacing(),
        cursor: 'pointer',
    },
    actionText: {
        display: 'inline-block',
    },
}));

const Section = ({
    title,
    subtitle,
    actionText,
    classes,
    editable,
    onAction,
}) => {
    return (
        <>
            <Divider className={classes.divider} />
            <div className={classes.root}>
                <div className={classes.infoColumn}>
                    <Typography variant="subtitle2">{title}</Typography>
                    <Typography variant="body2" color="textSecondary">
                        {subtitle}
                    </Typography>
                </div>
                <div className={classes.actionColumn}>
                    <Typography className={classes.actionText} variant="body2">
                        {actionText}
                    </Typography>
                    <Typography
                        className={classes.action}
                        color="secondary"
                        variant="body2"
                        onClick={onAction}
                    >
                        {editable ? 'Edit' : 'Show'}
                    </Typography>
                </div>
            </div>
        </>
    );
};

const TwoFactorForm = ({ data, onAction }) => {
    const classes = useStyles();
    return (
        <div>
            <Section
                title="Preferred method"
                subtitle="Choose how to get you security codes."
                actionText={getMethodByType(data.type)}
                editable
                onAction={() => onAction('method')}
                classes={classes}
            />
            <Section
                title="Backup method"
                subtitle="Providing a fall-back SMS number will allow CyberFOX Password Manager to send your two-factor authentication codes to an alternative device if you lose you primary device."
                editable
                actionText={
                    data.backup_phone
                        ? `SMS ${data.backup_phone}`
                        : 'Not configured'
                }
                onAction={() => onAction('backup_phone')}
                classes={classes}
            />
            <Section
                title="Recovery codes"
                subtitle="Recovery codes can be used to access your account in the event you lose access to your device."
                onAction={() => onAction('recovery_codes')}
                classes={classes}
            />
            <Divider className={classes.divider} />
        </div>
    );
};

export { TwoFactorForm };
